import React, { forwardRef } from 'react';
import NoteGrid from './NoteGrid';
import { usePlayChord } from '../hooks/usePlayChord';

/**
 * Adaptateur entre le magasin de l'accord et la grille des accords : App ne
 * passe plus l'accord courant, la grille le prend au magasin. forwardRef parce
 * que App garde une ref sur la grille pour lancer les accords au hasard.
 */
const PlayNoteGrid = forwardRef((props, ref) => {
  const { playingNote, activeChordNote } = usePlayChord();
  return (
    <NoteGrid
      ref={ref}
      {...props}
      activeChordNote={activeChordNote}
      playingNote={playingNote}
    />
  );
});

export default PlayNoteGrid;
